
function cycgetpdpswatchv2(swgroupid = '') {
       
      if(swgroupid == ''){
        swgroupid = cycggroupid;
      }

       var dataToSend = {
         id: cycgproductid,
         groupid: swgroupid,
         platformid:cycgplatformid,
         groupcolor:cycgroupcolor
      };
       
       var scriptUrl = 'https://myaccount.albeebaby.com/cyc/mod_shopifyfrontend/pdpswatchv2.php?pw=1212';
        //console.log(scriptUrl);
        var result = null;
        jQuery.ajax({
            async: true,
        	type: "POST",
                dataType: "text script", 
                data: JSON.stringify(dataToSend),
        	crossDomain: true,
        	url: scriptUrl,
           success : function(text)
            {
               //result = text;
            }
          });

        return result;
}

if (typeof cycgetpdpswatchv2 === "function") {
  cycgetpdpswatchv2(); 
}